import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoadingSpinner from '../loadspinner/loadspinner';

function UserDetails(props) {
    const { searchTerm } = props;
    const [caseManagerData, setCaseManagerData] = useState([]);
    const [emptyData, setEmptyData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tableSize, setTableSize] = useState(10);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);

    const tableHeaders = [
        'User Id',
        'Profile Status',
        'UUID',
        'User Onboarding TimeStamp',
        'Profile Creation TimeStamp',
    ];

    const tableSizeList = [5, 10, 15, 20];

    const onPageChange = (newPage) => {
        setPage(newPage);
    };

    const getCurrentUserToken = () => {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        return currentUser.token || '';
    }

    var userToken = getCurrentUserToken();
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`
    }
    
    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            try {
                const response = await axios.get('https://uat-api.adapid.link/api/v4/adaptive/userdetail/', { headers });
                const result = response.data;
                const tableData = result.message;
                setCaseManagerData(tableData.sort((a, b) => {
                    const c = +new Date(a.date);
                    const d = +new Date(b.date);
                    return d - c;
                }));
                setCount(result.message.length);
                setLoading(false);
            } catch (error) {
                if (error.response && error.response.data.message === "No record found") {
                    setEmptyData(true);
                }
                if (error.response && error.response.data.msg === "Token has expired") {
                    props.onLogout('token');
                }
                setLoading(false);
            }
        };
        getData();
    }, []);

    function filterName(searchTerm) {
        const filterData = caseManagerData.filter(profile =>
            profile.user_login_id.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return filterData;
    }

    return (
        <div>
            {loading ? (<LoadingSpinner />) : (
                <div className="main_case">
                    <div className="table_case">
                        <table>
                            <thead className="tablehead">
                                <tr>
                                    {tableHeaders.map((header, index) => (
                                        <th key={index}>{header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {searchTerm ? filterName(searchTerm).slice((page - 1) * tableSize, page * tableSize).map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.user_login_id}</td>
                                        <td>{row.profile_status}</td>
                                        <td>{row.user_id}</td>
                                        <td>
                                            {new Date(row.user_onboard_time).toLocaleString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: 'numeric',
                                                minute: 'numeric',
                                                second: 'numeric',
                                                hour12: true,
                                                timeZone: 'Asia/Kolkata',
                                            })}
                                        </td>
                                        <td>
                                            {row.profile_created_time === "Pending"
                                                ? 'Pending'
                                                : new Date(row.profile_created_time).toLocaleString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric',
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric',
                                                    hour12: true,
                                                    timeZone: 'Asia/Kolkata',
                                                })}
                                        </td>
                                    </tr>
                                ))
                                    : caseManagerData.slice((page - 1) * tableSize, page * tableSize).map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.user_login_id}</td>
                                            <td>{row.profile_status}</td>
                                            <td>{row.user_id}</td>
                                            <td>
                                                {new Date(row.user_onboard_time).toLocaleString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric',
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric',
                                                    hour12: true,
                                                    timeZone: 'Asia/Kolkata',
                                                })}
                                            </td>
                                            <td>
                                                {row.profile_created_time === "Pending"
                                                    ? 'Pending'
                                                    : new Date(row.profile_created_time).toLocaleString('en-US', {
                                                        year: 'numeric',
                                                        month: 'short',
                                                        day: 'numeric',
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric',
                                                        hour12: true,
                                                        timeZone: 'Asia/Kolkata',
                                                    })}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="paginator">
                        <div className="itemSize">
                            <label htmlFor="tableSize">Items per page:</label>
                            <select
                                name="tableSize"
                                id="tableSize"
                                value={tableSize}
                                onChange={(e) => setTableSize(parseInt(e.target.value))}>
                                {tableSizeList.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="itemValue">
                            <span>
                                {searchTerm
                                    ? `${tableSize * (page - 1) + 1}-${Math.min(tableSize * page, filterName(searchTerm).length)} of ${filterName(searchTerm).length}`
                                    : `${tableSize * (page - 1) + 1}-${Math.min(tableSize * page, count)} of ${count}`}
                            </span>
                        </div>
                        <div className="item">
                            <button
                                className="previous"
                                onClick={() => onPageChange(page - 1)}
                                disabled={page === 1}>
                                Previous
                            </button>
                            <button
                                className="next"
                                onClick={() => onPageChange(page + 1)}
                                disabled={page === Math.ceil(count / tableSize)}>
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {emptyData && <div className="empty-data" style={{ height: "600px" }}><span>No Results Found</span></div>}
        </div>
    );
}

export default UserDetails;

